import axios from "axios";

const url = "https://api.universal-iot.com";
const project = "kiic";
const version = "v-1"

export default axios.create({
    baseURL: `${url}/rest-${project}/${version}/`
  });
